// This file is generated using scripts/generate-icon-components/utils.js
// Don't edit it manually
import React from 'react';

const IconCalendar = (props: React.SVGProps<SVGElement>) =>
  /*#__PURE__*/ React.createElement(
    'svg',
    {
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      xmlns: 'http://www.w3.org/2000/svg',
      ...props
    },
    /*#__PURE__*/ React.createElement('path', {
      d: 'M7.143 7.902h9.638M6.485 2.437v1.64m10.828-1.64v1.64m3.187 3v11.486a3 3 0 0 1-3 3h-11a3 3 0 0 1-3-3V7.076a3 3 0 0 1 3-3h11a3 3 0 0 1 3 3z',
      stroke: 'current',
      strokeWidth: '2',
      strokeLinecap: 'round',
      strokeLinejoin: 'round'
    })
  );

export { IconCalendar };
